{
  "en": {
    "action": {
      "one": "Action",
      "other": "Actions"
    },
    "activate": "Activate",
    "activerecord": {
      "attributes": {
        "article": {
          "kind": "Kind",
          "title": "Title"
        },
        "article/topic": {
          "title": "Title"
        },
        "campaign": {
          "description": "Description",
          "name": "Name",
          "url": "URL"
        },
        "championship": {
          "name": "Name"
        },
        "editor": {
          "email": "Email",
          "promoter_role_id": "Role"
        },
        "enrollment": {
          "due_date": "Due date",
          "period": "Frequency",
          "status": "Status"
        },
        "evaluation_group": {
          "name": "Name"
        },
        "evaluation_option": {
          "evaluation_group_id": "group",
          "name": "Name"
        },
        "event": {
          "end_at": "End Date",
          "name": "Name",
          "start_at": "Start date",
          "status": "Status",
          "total_of_comments": "Comments",
          "total_of_votes": "Likes"
        },
        "grade": {
          "name": "Name"
        },
        "invoice": {
          "customer_email": "Customer Email",
          "customer_name": "Client",
          "description": "Description",
          "due_date": "Due date",
          "paid_at": "Pay day",
          "tax_cents": "Rate",
          "total_cents": "Value",
          "total_liquid_cents": "Total"
        },
        "level": {
          "name": "Name"
        },
        "model": {
          "default": "Default",
          "group": "Group",
          "name": "Name"
        },
        "nota_fiscal": {
          "data_competencia": "Service Date"
        },
        "payment_account": {
          "bank_account": {
            "kind": "Type",
            "number": "Number"
          },
          "boleto_cents": "Boleto",
          "credit_card_cents": "Credit Card",
          "credit_card_description": "Name on Card",
          "credit_card_percent": "Credit Card",
          "default": "Default",
          "name": "Name",
          "person_type": "Person Type",
          "pix_percent": "Pix",
          "withdraw_cents": "Withdrawal"
        },
        "payment_category": {
          "name": "Name"
        },
        "payment_method": {
          "name": "Name",
          "tax_amount_input_cents": "Value at input",
          "tax_amount_output_cents": "Value at output",
          "tax_percentage_input_cents": "Percentage on entry",
          "tax_percentage_output_cents": "Output percentage"
        },
        "plan": {
          "highlight": "Emphasis",
          "name": "Name"
        },
        "product": {
          "amount": "Value",
          "featured": "Emphasis",
          "name": "Name",
          "quantity": "The amount",
          "sold": "Sold",
          "visible": "Visible"
        },
        "product_option_type": {
          "presentation": "Presentation"
        },
        "rhythm": {
          "name": "Name",
          "parent_id": "Rhythm Father"
        },
        "role": {
          "description": "Description",
          "name": "Name"
        },
        "subscription": {
          "charge_date": "Charge",
          "due_date": "Due Date",
          "end_date": "End",
          "status": "Status",
          "trial_days": "Trial"
        },
        "tag": {
          "description": "Description",
          "name": "Name"
        },
        "ticket_order_item": {
          "checkin": "Check-in"
        },
        "unit": {
          "name": "Name"
        },
        "user": {
          "birthdate": "Birth",
          "email": "Email",
          "first_class_at": "Trial class",
          "name": "Name"
        },
        "withdraw": {
          "amount_cents": "Net Value",
          "bank_agency": "Agency",
          "bank_kind": "Type",
          "bank_number": "Number",
          "paying_at": "Forecast",
          "tax_cents": "Fee",
          "total_cents": "Gross Value"
        }
      },
      "models": {
        "address": {
          "one": "Address"
        },
        "article": {
          "other": "Articles"
        },
        "bank": {
          "one": "Bank"
        },
        "contract": {
          "one": "Contract"
        },
        "coupon": {
          "one": "Coupon"
        },
        "credit": {
          "other": "Credits"
        },
        "email": {
          "one": "Email"
        },
        "enrollment": {
          "one": "Enrollment",
          "other": "Enrollments"
        },
        "examiner": {
          "one": "Examiner",
          "other": "Examiners"
        },
        "face": {
          "one": "Face"
        },
        "grade": {
          "one": "Grade"
        },
        "graduation": {
          "other": "Graduations"
        },
        "invoice": {
          "one": "Invoice"
        },
        "level": {
          "one": "Level"
        },
        "message": {
          "one": "Mensagem"
        },
        "nota_fiscal": {
          "one": "Nota Fiscal"
        },
        "notification": {
          "other": "Notifications"
        },
        "order": {
          "one": "Order"
        },
        "payment_method": {
          "one": "Payment Method"
        },
        "period": {
          "one": "Time course"
        },
        "permission": {
          "other": "Permissions"
        },
        "phone": {
          "one": "Telephone"
        },
        "plan": {
          "one": "Plan"
        },
        "profile": {
          "one": "Profile"
        },
        "prospect": {
          "other": "Prospects"
        },
        "rhythm": {
          "other": "Rhythms"
        },
        "role": {
          "one": "Profile"
        },
        "school_course": {
          "one": "Course"
        },
        "student": {
          "one": "Student"
        },
        "subscription": {
          "one": "Subscription",
          "other": "Subscriptions"
        },
        "tax": {
          "one": "Tax"
        },
        "teacher": {
          "one": "Teacher",
          "other": "teachers"
        },
        "ticket": {
          "one": "Ticket",
          "other": "Tickets"
        },
        "unit": {
          "one": "Unit",
          "other": "Units"
        },
        "user": {
          "one": "User"
        },
        "user_note": {
          "other": "User Notes"
        }
      }
    },
    "add_one_more": {
      "charge_card": "Charge on card",
      "invoice": "Add +1 invoice"
    },
    "allowed": "Allowed",
    "amount": "Value",
    "approved": {
      "other": "Approved"
    },
    "artistic_name": "Artistic Name",
    "blocked": "Blocked",
    "cancel": "Cancel",
    "cancel_at": "Cancel at",
    "charge": {
      "verb": "To Charge"
    },
    "checkin": {
      "back_camera": "Back camera",
      "face_too_far": "Bring your face closer",
      "front_camera": "Front camera",
      "identifying": "Identifying",
      "no_face": "No face detected",
      "one_face": "Only one face at a time",
      "quota": "Check-ins",
      "scan_error": "Error identifying. Please try again.",
      "unlimited": "Unlimited"
    },
    "checkout": {
      "loading_message": "The invoice is being processed, please wait."
    },
    "code": "Code",
    "controller": "Controller",
    "copied": "copied!",
    "copy_link": "copy link",
    "create_searched_user": "Create searched user",
    "created_at": {
      "female": "Created at",
      "male": "Created at"
    },
    "current_plan": "Current plan",
    "cycle": {
      "one": "Cycle"
    },
    "dancer": {
      "role": {
        "one": "Role"
      }
    },
    "dashboard": "Dashboard",
    "date": {
      "one": "Date"
    },
    "datepicker": {
      "format": "dd/MM/yy",
      "next_month": "Next month",
      "placeholder": "__/__/__",
      "previous_month": "Last month"
    },
    "default": "Default",
    "description": {
      "one": "Description"
    },
    "detail": {
      "other": "Details"
    },
    "disapproved": {
      "other": "Failed"
    },
    "discount": {
      "one": "Discount"
    },
    "document": {
      "one": "Document"
    },
    "due_date": "Due date",
    "edit": "Edit",
    "email": "E-mail",
    "end": {
      "one": "End"
    },
    "enrollment": {
      "charge": {
        "confirm_charge": "Do you really want to charge?"
      }
    },
    "evaluate": "Evaluate",
    "exam": {
      "other": "Exams"
    },
    "expires_at": "Expires at",
    "face": {
      "delete": {
        "confirm": "Are you sure you want to delete this face?"
      },
      "switch_camera": "Switch camera"
    },
    "fail": {
      "one": "Fail"
    },
    "finish_and_graduate": "Finish and Graduate",
    "follow": {
      "one": "Follower",
      "other": "Followers"
    },
    "graduation": {
      "profile": {
        "not_selected": "Profile not selected"
      },
      "role": {
        "not_selected": "Role not selected"
      }
    },
    "gridy": {
      "errors": {
        "record_not_found": "No results."
      },
      "page": {
        "button": {
          "back": "< previous page",
          "next": "next page >",
          "title": "Page"
        }
      },
      "refresh": {
        "title": "reload"
      },
      "search": {
        "label": "Query text",
        "placeholder": "Type here what you are looking for"
      },
      "status": {
        "full": "Page {from} of {to} | {total} records",
        "one": "1 record found",
        "other": "{total} records found",
        "zero": ""
      }
    },
    "gross": "Gross",
    "highlight": "Featured",
    "id": "ID",
    "invoice": {
      "charge": {
        "confirm": "Charge this invoice on the student's credit card?"
      },
      "statuses": {
        "refunded": "Refunded"
      },
      "tip": {
        "refunded": "Refunded: %{comment}"
      }
    },
    "kind": {
      "one": "Kind"
    },
    "lead": {
      "one": "Leader",
      "other": "Leaders"
    },
    "liquid": "Liquid",
    "menu": {
      "one": "Menu"
    },
    "method": "Method",
    "mock": {
      "other": "Mock"
    },
    "months": {
      "short": {
        "abr": "Apr",
        "ago": "Aug",
        "dez": "Dec",
        "fev": "Feb",
        "jan": "Jan",
        "jul": "Jul",
        "jun": "Jun",
        "mai": "May",
        "mar": "Mar",
        "nov": "Nov",
        "out": "Oct",
        "set": "Sep"
      }
    },
    "move": {
      "down": "Move down",
      "up": "Move up",
      "verb": "Move"
    },
    "name": "Name",
    "no_result": "No result",
    "not_found": {
      "female": "Not found",
      "male": "Not found"
    },
    "nota_fiscal": {
      "cancel": {
        "confirm": "Are you sure you want to cancel the nota fiscal?",
        "verb": "Cancel Nota Fiscal"
      },
      "create": {
        "confirm": "Are you sure you want to issue the nota fiscal?",
        "short": "Issue",
        "verb": "Issue Nota Fiscal"
      },
      "show": {
        "verb": "Show Nota Fiscal"
      }
    },
    "notify": "Notify",
    "order": {
      "cancel": {
        "confirm": "Are you sure you want to cancel this order?"
      },
      "charge_failure_prefix": "Charge failed",
      "schedule_cancel": {
        "confirm": "Are you sure you want to schedule the cancellation?"
      }
    },
    "pagarme": "Pagar.me",
    "paid_at": "Paid at",
    "payment_method": {
      "short": "Method"
    },
    "pending": {
      "other": "Pending"
    },
    "percentage": {
      "one": "Percentage"
    },
    "push_notification": {
      "confirm_question": "For a full experience, we will ask you for permission for notifications.",
      "denied_message": "Notifications disabled, to enable authorize in your browser.",
      "manual_revoking": "You need to remove permission directly from your browser.",
      "status": {
        "default": "Enable notifications for new features.",
        "denied": "Notifications blocked. To enable, configure your browser.",
        "granted": "Activate notifications.",
        "unsupported": "Notifications not supported on this device/browser/version."
      }
    },
    "rating": {
      "hints": {
        "basic": {
          "five": "Excellent",
          "four": "Good",
          "one": "Terrible",
          "three": "Regular",
          "two": "Bad"
        },
        "evaluation": {
          "four": "Excellent",
          "one": "reason for failure",
          "three": "Good",
          "two": "To train"
        }
      },
      "no_rated_msg": "No reviews yet."
    },
    "recurrence": {
      "one": "Recurrence"
    },
    "refund": {
      "verb": "To Refund"
    },
    "renew": {
      "one": "Automatic renewal"
    },
    "result": {
      "one": "Result",
      "other": "Results"
    },
    "show": "Show",
    "show_all": "Show All",
    "signed": "Signed",
    "slug": "URL",
    "start": {
      "one": "Start"
    },
    "status": "Status",
    "subscription": {
      "cancel_date": "Cancelation date",
      "uncancel": {
        "one": "Reactivate subscription"
      }
    },
    "subtotal": "Subtotal",
    "system": {
      "dashboards": {
        "index": {
          "create_checkin_confirm": "Confirm this student check-in today?",
          "enable_credit": "Enable credits function",
          "enrollments_not_found": "No active or overdue enrollments found.",
          "new_enrollment": "New enrollment",
          "new_subscription": "New subscription",
          "new_subscription_disabled_tooltip": "The student already has an active or overdue subscription.",
          "register_as_student": "Register as a student",
          "subscriptions_not_found": "No active or overdue subscriptions found."
        }
      },
      "evaluation_options": {
        "rating": "Rating for %{name}",
        "rating_scored": "Rating for %{name}: %{score}"
      },
      "subscriptions": {
        "form": {
          "generate_first_invoice": "Generate first invoice ?",
          "generate_first_invoice_credit_card": "Perform the first charge on the credit card ?"
        }
      }
    },
    "time": {
      "one": "Time"
    },
    "today": "Today",
    "total": "Total",
    "transfer": {
      "verb": "Transfer"
    },
    "user": {
      "not_student": "is not a student at this unit."
    },
    "user_unit_access": {
      "denied": "The student must authorize access to their personal data to perform this action. Request access now?",
      "request": {
        "confirm": "Send notification to the student requesting access to personal data?",
        "verb": "Request access"
      }
    },
    "wait": "Wait...",
    "whatsapp": "WhatsApp"
  }
}